import { Component, ContentChild, Directive, ElementRef, HostListener, Input, Renderer2, TemplateRef } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Directive({ selector: '[gq-button-content' })
export class GqButtonContentTemplate {
  constructor(public template: TemplateRef<any>) { }
}

@Component({
  selector: 'gq-button',
  templateUrl: './gq-button.component.html',
  styleUrls: ['./gq-button.component.scss'],
})
export class GqButtonComponent {

  @Input() public icon = "";
  @Input() public iconPosition: "left" | "right" = "left";
  @Input() public label = "";
  @Input() public titleText = "";
  @Input() public type: "icon" | "flat" | "stroked" | "link" = "flat";
  @Input() public color: ThemePalette | "secundary" = "primary";
  @Input() public get disabled(): boolean { return this._disabled; }
  @Input() public toggle: boolean = false;
  @Input() public isSelected: boolean = false;

  public set disabled(val: boolean) {
    this._disabled = val;
    if (this._disabled)
      this.render.setStyle(this.el.nativeElement, 'pointer-events', 'none');
    else
      this.render.removeStyle(this.el.nativeElement, 'pointer-events');
  }

  private _disabled: boolean = false;


  @ContentChild(GqButtonContentTemplate, { read: TemplateRef, static: false }) contentTemplate: TemplateRef<any> | null = null;

  constructor(private render: Renderer2, private el: ElementRef<HTMLDivElement>) {

  }

  @HostListener('click', ['$event'])
  public onClick(event: any) {
    if (this.toggle && !this._disabled) {
      this.isSelected = !this.isSelected;
    }
  }

  public getTemplate(text: any, left: any, right: any): TemplateRef<any> {
    return (this.icon !== '' ? (this.iconPosition == 'left' ? left : right) : text);
  }
}
